import React from "react";

const RotateIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <g clip-path="url(#clip0_3_504)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.0391 3.76123C23.5913 3.76123 24.0391 4.20895 24.0391 4.76123V10.7612C24.0391 11.3135 23.5913 11.7612 23.0391 11.7612H17.0391C16.4868 11.7612 16.0391 11.3135 16.0391 10.7612C16.0391 10.2089 16.4868 9.76123 17.0391 9.76123H22.0391V4.76123C22.0391 4.20895 22.4868 3.76123 23.0391 3.76123Z"
        fill="#006EFF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1704 4.84248C11.453 4.59889 9.703 4.92005 8.18406 5.75759C6.66511 6.59512 5.45952 7.90364 4.74895 9.48597C4.03839 11.0683 3.86135 12.8387 4.24451 14.5304C4.62767 16.2221 5.55028 17.7434 6.8733 18.8652C8.19632 19.9869 9.84808 20.6482 11.5797 20.7495C13.3113 20.8508 15.0289 20.3866 16.4737 19.4268C17.9185 18.467 19.0122 17.0636 19.59 15.4281C19.7739 14.9074 20.3452 14.6344 20.866 14.8184C21.3867 15.0023 21.6597 15.5736 21.4757 16.0944C20.7535 18.1387 19.3863 19.8929 17.5804 21.0927C15.7744 22.2925 13.6274 22.8728 11.4629 22.7461C9.29838 22.6195 7.23368 21.7928 5.57991 20.3907C3.92613 18.9885 2.77287 17.0868 2.29392 14.9722C1.81496 12.8576 2.03626 10.6446 2.92447 8.66666C3.81268 6.68875 5.31967 5.0531 7.21835 4.00618C9.11703 2.95927 11.3045 2.55781 13.4512 2.8623C15.5928 3.16606 17.578 4.15599 19.1092 5.68338L23.7284 10.0332C24.1305 10.4119 24.1495 11.0447 23.7709 11.4468C23.3922 11.8489 22.7594 11.8679 22.3573 11.4893L17.7273 7.12926C17.7199 7.12233 17.7127 7.11528 17.7055 7.10813C16.4794 5.88123 14.8877 5.08607 13.1704 4.84248Z"
        fill="#006EFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_504">
        <rect width="24" height="24" fill="white" transform="translate(0.0390625 0.76123)" />
      </clipPath>
    </defs>
  </svg>
);
export default RotateIcon;
